const { getElement } = window.BAO.Utils

class GiftBar extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['added', 'input']
  }

  setupListeners () {
    super.setupListeners()

    this.onSelfClick = this.onSelfClick.bind(this)

    this.listeners.add(this, 'click', this.onSelfClick)
  }

  onSelfClick (event) {
    event.preventDefault()

    this.giftDrawer.activator = this
    this.giftDrawer.productId = this.dataset.productId
    this.giftDrawer.variantId = this.dataset.variantId

    if (this.extrasIds.length > 0) {
      this.giftDrawer.extras.forEach(el => {
        el.setAttribute(
          'aria-selected',
          this.extrasIds.includes(Number(el.dataset.variantId)).toString(),
        )
      })
    }

    window.drawers.activeDrawerKey = this.drawerId
  }

  get drawerId () {
    return 'gifting'
  }

  get giftDrawer () {
    return getElement('gift-drawer')
  }

  get applyAsAdd () {
    return this.dataset.applyAsAdd === 'true'
  }

  get applyAsUpdate () {
    return this.dataset.applyAsUpdate === 'true'
  }

  get giftingMessage () {
    if (!this?.els?.added) return ''

    return this.els.added.element.value
  }

  /**
   * @returns {boolean}
   * @public
   */
  get hasGifting () {
    return this.dataset.active === 'true'
  }

  /**
   * @param {boolean} val
   */
  set hasGifting (val) {
    this.dataset.active = val.toString()

    this.els.input.element.checked = val
  }

  /**
   * @type {number[]}
   * @public
   */
  get extrasIds () {
    const ids = this.dataset.extrasIds.split(',').filter(Boolean)
    if (ids.length === 0) return []

    return ids.map(id => Number(id))
  }

  /**
   * @param {number[]} val
   */
  set extrasIds (val) {
    this.dataset.extrasIds = val.join(',')
  }

  /**
   * @type {number[]}
   * @public
   */
  get extrasIdsFree () {
    const ids = this.dataset.extrasIdsFree.split(',').filter(Boolean)
    if (ids.length === 0) return []

    return ids.map(id => id)
  }

  /**
   * @param {number[]} val
   */
  set extrasIdsFree (val) {
    this.dataset.extrasIdsFree = val.join(',')
  }

  /**
   * @type {number[]}
   * @public
   */
  get extrasIdsTypes () {
    const types = this.dataset.extrasIdsTypes.split('|')

    return types.map(id => id)
  }

  /**
   * @param {number[]} val
   */
  set extrasIdsTypes (val) {
    this.dataset.extrasIdsTypes = val.join(',')
  }

  /** @returns {string} */
  get productType () {
    return this.dataset.productType ?? 'default'
  }
}

if (!customElements.get('gift-bar')) {
  customElements.define('gift-bar', GiftBar)
}
